import { createAsyncThunk } from "@reduxjs/toolkit";
import { promiseFetchDataAuth } from 'crk-front-lib';
// import { makeKeySubValue } from 'crk-lib-tool/tools/json-util';

const APIPATH = '/api/v2/member';

export const readProfile = createAsyncThunk('members/readProfile', async (member_id, thunkAPI) => {
  const url = `${APIPATH}/profile`;
  const result = await promiseFetchDataAuth(url);

  // makeKeySubValue(result);

  return result;
})

export const updateProfile = createAsyncThunk('members/updateProfile', async (data, thunkAPI) => {
  const {user_id: member_id, fullname, mobile, bill_addr, postcode} = data;
  const url = `${APIPATH}/profile/${member_id}`;
  const result = await promiseFetchDataAuth(url, 'PATCH', { fullname, mobile, bill_addr, postcode });  
  
  return result;
})

/*
export const changeStatus = createAsyncThunk('members/changeStatus', async ({member_id, status}, thunkAPI) => {
  const url = `${APIPATH}/members/${member_id}`;
  const result = await promiseFetchDataAuth(url, 'PATCH', { status });  

  return result;
})
*/
